import React from 'react'
import {Link} from 'react-router-dom'
import './Form.scss'

export default function () {
  return(
    <div className="form-wrapper-contact">
      <form name="private-event" method="POST" data-netlify="true">
        <h2>Private Events Inquiry</h2>

        <p>Contact us for more information about hosting your next event with us.</p>
        {/* <p>Sign up to be notified when we open</p> */}


        <input type="hidden" name="form-name" value="private-event" />
        <p>
          <label><span className="label-text">Name:</span> <input required type="text" name="name" /></label>
        </p>
        <p>
          <label><span className="label-text">Email:</span> <input required type="email" name="email" /></label>
        </p>
        <p>
          <label><span className="label-text">Phone:</span> <input required type="telephone" name="phone" /></label>
        </p>
        <p>
          <label><span className="label-text">Message:</span> <textarea type="text" name="message" /></label>
        </p>
        <p>
          <label><span className="label-text">Date:</span> <input type="datetime-local" name="time" /></label>
        </p>
       
        {/* <p>
          <label>Optional Zipcode: (to help us plan our locations)
          <br/><input type="zipcode" name="zipcode" /></label>
        </p> */}
        {/* <p>
          <label>Message: <textarea name="message"></textarea></label>
        </p> */}
        <p>
          <button type="submit">Submit</button>
        </p>
      </form>
    </div>
  )
}
